import { useCallback, type FunctionComponent } from 'react';

import { Popover, PopoverPlacement, usePopover } from '@trello/nachos/popover';
import { useIsRovoIslandEnabled } from '@trello/rovo';
import type { WorkspaceNavigationTestIds } from '@trello/test-ids';
import { getTestId } from '@trello/test-ids';

import { IslandNav } from 'app/src/components/IslandNav';
import { RovoButton } from 'app/src/components/RovoButton';

import styles from './RovoIsland.less';

export const RovoIsland: FunctionComponent = () => {
  const isRovoIslandEnabled = useIsRovoIslandEnabled();

  const { targetRef, triggerRef, toggle, popoverProps } = usePopover({
    placement: PopoverPlacement.TOP_START,
  });

  const toggleRovoChat = useCallback(() => {
    // TODO: Add analytics
    toggle();
  }, [toggle]);

  if (!isRovoIslandEnabled) {
    return null;
  }

  return (
    <IslandNav
      ref={targetRef}
      buttonGroupClassName={styles.buttonGroup}
      className={styles.container}
      data-testid={getTestId<WorkspaceNavigationTestIds>('rovo-island')}
    >
      <RovoButton
        isActive={popoverProps.isVisible}
        onClick={toggleRovoChat}
        triggerRef={triggerRef}
      />
      <Popover
        {...popoverProps}
        noHorizontalPadding
        noVerticalPadding
        dangerous_width={400}
        placement="bottom-end"
      >
        {/* TODO: Add Rovo Chat Interface */}
      </Popover>
    </IslandNav>
  );
};
